export const ColdChainTranslationsDictionary = {
    // Page
    ColdChain: "Cold Chain",

    // Zone labels
    Zone1: "Zone 1",
    Zone2: "Zone 2",
    Zone3: "Zone 3",

    // Data labels
    UnitStatus: "Unit Status",
    Temperature: "Temperature",
    Setpoint: "Set-point",

    // Unit status values
    StatusDisabled: "Disabled",
    StatusOn: "On",
    StatusOff: "Off",
    StatusError: "Error",
    StatusUnknown: "Unknown",

    // Staleness message
    LastUpdatedJustNow: "Last updated just now",
    LastUpdatedMinuteAgo: "Last updated {0} minute ago",
    LastUpdatedMinutesAgo: "Last updated {0} minutes ago",

    // Loading / empty states
    Loading: "Loading...",
    NoDataAvailable: "No data available.",

    // Error messages
    NoUserSession: "No user session found.",
    NoAssetAssigned: "No asset assigned to you.",
    NoColdChainData: "No Cold Chain data available from this source.",
    FailedToLoad: "Failed to load cold chain data.",
    NoLinkedAssets: "No cold chain assets linked to your vehicle.",
    NoColdChainDeviceAssociated: "No Cold Chain source associated with this Asset.",

    // Alert notifications
    SetPointExceededFormat: "Set point exceeded: {0} Zone {1}",
    YourVehicle: "your vehicle",

    // Zone card breach state
    Breached: "Breached",

    // Delivery proof
    DeliveryProofTitle: "Delivery proof",
    GenerateDeliveryProof: "Generate delivery proof",
    GeneratingDeliveryProof: "Generating delivery proof...",
    NoTripForProof: "No trip is available yet for your vehicle. A delivery proof can only be generated once a trip has started.",
    GenerateProofFailed: "We couldn't generate the delivery proof. Try again.",
    ProofOutcomeCompliant: "Compliant",
    ProofOutcomeBreached: "Breached",
    ProofOutcomeIncomplete: "Incomplete evidence - compliance cannot be confirmed",
    ProofProvisionalFormat: "Provisional — evaluated through {0}; trip in progress",
    ToleranceUsedFormat: "Tolerance used: ±{0}° (current configuration)",
    ToleranceUnavailable: "Tolerance unavailable — this zone is incomplete.",
    TripStart: "Trip start",
    EvaluationEnd: "Evaluation end",
    GeneratedAt: "Generated at",
    Vehicle: "Vehicle",
    BreachIntervals: "Breach intervals",
    DataGaps: "Data gaps",
    ToleranceLabel: "Tolerance",
    LegendLabel: "Legend",
    NoBreachIntervals: "No breach intervals.",
    NoDataGaps: "No data gaps.",
    IntervalFromToFormat: "{0} to {1}",
    IntervalOngoing: "ongoing",
    ChartSummaryFormat: "Temperature over time chart for {0}. Outcome: {1}. Intervals: {2}.",
    ChartLegendTemperature: "Cargo temperature",
    ChartLegendSetpoint: "Set-point",
    EvidenceListHeading: "Evidence intervals",
    IntervalStatusCompliant: "Compliant",
    IntervalStatusApproaching: "Approaching limit",
    IntervalStatusBreached: "Breached",
    IntervalStatusUnknown: "Unknown",
    DeliveryProofAnnotationFormat: "Delivery proof generated at {0}",
    ProofDisclaimer: "This proof is informational evidence derived from the fleet's configured stock-rule criteria and the telematics " +
        "available to Drive. It is not tamper-evident and does not by itself certify compliance with any food-safety regulation.",
    CreatePdf: "Create PDF",
    CreatingPdf: "Creating PDF...",
    CreatePdfFailed: "Could not create the PDF. Try again.",
    MapAltText: "Map showing the vehicle's trip path for location context only.",
    AssetCount: "{0} asset(s) included",
    NoZoneEvidence: "No zone evidence available for this asset for the delivery trip window."
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in ColdChainTranslationsDictionary) {
        r.push(ColdChainTranslationsDictionary[prop as keyof typeof ColdChainTranslationsDictionary]);
    }
    return r;
};

export const ColdChainTranslations = getTranslations();
